var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shield") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active-title-nav",
    transform: "translate(-34.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shield",
    transform: "translate(34.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33577668,20.8262912 C8.47768967,20.9278585 8.66850447,20.9278585 8.81041746,20.8262912 C12.9696407,17.8553009 17.1466019,16.5516699 17.1466019,10.4382233 L17.1466019,2.87047572 C17.1466019,2.65817885 16.9838537,2.48134036 16.7722718,2.46393203 L15.7120776,2.37524271 C13.2542888,2.16391501 10.8819364,1.37138383 8.79064076,0.0629999999 C8.65826637,-0.0198971649 8.49017048,-0.0198971649 8.3577961,0.0629999999 C6.26638338,1.37145196 3.89388235,2.1639861 1.43595145,2.37524271 L0.375757281,2.46393203 C0.164175343,2.48134036 0.00142686379,2.65817885 0.00142686379,2.87047572 L0.00142686379,10.4392427 C1.38107841e-13,16.7239514 4.76271844,18.2742815 8.33577668,20.8262912 Z M0.816349513,3.2450097 L1.50302912,3.18771844 C4.00499375,2.97330189 6.42411542,2.18627465 8.57330095,0.887504852 C10.7222831,2.18623253 13.1411966,2.97326015 15.6429611,3.18771844 L16.3296407,3.2450097 L16.3296407,10.4382233 C16.3296407,15.9506213 12.6568835,17.1333495 8.57248542,19.9944466 C4.9880097,17.5070679 0.816349513,16.0945631 0.816349513,10.4382233 L0.816349513,3.2450097 Z",
    id: "Path_460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33516503,17.8589708 C8.47938231,17.9588231 8.67149299,17.9544607 8.81102911,17.848165 C12.5068252,15.2900388 14.6969421,14.4484077 14.6969421,10.438631 L14.6969421,5.08526213 C14.6972324,4.88306511 14.549306,4.7111928 14.3493204,4.68136892 C12.3998895,4.38904251 10.5117262,3.77843557 8.76026212,2.87394174 C8.6362293,2.8110706 8.48894811,2.81451533 8.36799027,2.8831165 C6.62175165,3.78273251 4.73992813,4.39019448 2.79728155,4.68136892 C2.59729591,4.7111928 2.44936947,4.88306511 2.44965976,5.08526213 L2.44965976,10.4396505 C2.44945631,14.4861262 4.84875727,15.4796505 8.33516503,17.8589708 Z M8.16043688,16.758 C5.03184465,14.6753301 3.26560193,13.7849708 3.26560193,10.4392427 L3.26560193,5.43186407 C4.95990487,5.14533551 6.60687794,4.62767228 8.16043688,3.89335922 L8.57289319,3.69294174 L8.97719416,3.8898932 C10.5334459,4.62590328 12.1833893,5.14473917 13.8807961,5.43186407 L13.8807961,10.4382233 C13.8807961,13.7568349 12.3265922,14.4806213 8.97800969,16.7449514 L8.57370872,17.0436407 L8.16043688,16.758 Z",
    id: "Path_461"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path_462",
    stroke: "#DF6532",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.55276698 10.7562815 8.1700194 13.7026019 12.6615728 7.03398057"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.122dbe23.svg";
export { ForwardRef as ReactComponent };